var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.isLoadingOverlayShown || _vm.isShowPreLoader ? [_c('client-only', [_c('v-lottie', {
    attrs: {
      "position": "fixed"
    }
  })], 1)] : _vm._e(), _vm._v(" "), _c('form', {
    attrs: {
      "autocomplete": "on"
    },
    on: {
      "submit": function ($event) {
        $event.preventDefault();
      },
      "keyup": _vm.cathEventCodes
    }
  }, [_c('div', {
    staticClass: "display-flex flex-column align-items-start gap-10 w-100 relative z-index-10"
  }, [_c('div', {
    staticClass: "w-100"
  }, [_c('div', {
    staticClass: "general-input"
  }, [_c('div', {
    class: [`field field-text`, {
      'field-invalid': _vm.errors.has('email'),
      'field-filled': _vm.loginInfo.email.length
    }]
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.loginInfo.email,
      expression: "loginInfo.email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: 'required|email',
      expression: "'required|email'"
    }],
    class: ['input', {
      invalid: _vm.errors.has('email'),
      empty: _vm.loginInfo.email.length <= 0
    }],
    attrs: {
      "id": "email",
      "type": "text",
      "name": "email",
      "data-testid": "email-input",
      "data-vv-validate-on": "blur",
      "autocomplete": "on"
    },
    domProps: {
      "value": _vm.loginInfo.email
    },
    on: {
      "focus": function ($event) {
        return _vm.$validator.errors.remove('email');
      },
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.loginInfo, "email", $event.target.value);
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "email",
      "data-testid": "email-label"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('placeholders.text.field.email')) + "\n            ")])]), _vm._v(" "), _vm.errors.first('email') ? _c('div', {
    staticClass: "field-error",
    attrs: {
      "data-testid": "email-field-error"
    }
  }, [_c('p', [_vm._v("\n              " + _vm._s(_vm.errors.first('email')) + "\n            ")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "w-100"
  }, [_c('div', {
    staticClass: "general-input"
  }, [_c('div', {
    class: [`field field-text`, {
      'field-invalid': _vm.errors.has('password'),
      'field-filled field-password': _vm.loginInfo.password.length
    }]
  }, [(_vm.passwordFieldType ? 'password' : 'text') === 'checkbox' ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.loginInfo.password,
      expression: "loginInfo.password"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: 'required|min:6',
      expression: "'required|min:6'"
    }],
    class: ['input', {
      invalid: _vm.errors.has('password'),
      empty: _vm.loginInfo.password.length <= 0
    }],
    attrs: {
      "id": "password",
      "name": "password",
      "data-testid": "password-input",
      "data-vv-validate-on": "blur",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.loginInfo.password) ? _vm._i(_vm.loginInfo.password, null) > -1 : _vm.loginInfo.password
    },
    on: {
      "focus": function ($event) {
        return _vm.$validator.errors.remove('password');
      },
      "change": function ($event) {
        var $$a = _vm.loginInfo.password,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.loginInfo, "password", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.loginInfo, "password", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.loginInfo, "password", $$c);
        }
      }
    }
  }) : (_vm.passwordFieldType ? 'password' : 'text') === 'radio' ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.loginInfo.password,
      expression: "loginInfo.password"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: 'required|min:6',
      expression: "'required|min:6'"
    }],
    class: ['input', {
      invalid: _vm.errors.has('password'),
      empty: _vm.loginInfo.password.length <= 0
    }],
    attrs: {
      "id": "password",
      "name": "password",
      "data-testid": "password-input",
      "data-vv-validate-on": "blur",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.loginInfo.password, null)
    },
    on: {
      "focus": function ($event) {
        return _vm.$validator.errors.remove('password');
      },
      "change": function ($event) {
        return _vm.$set(_vm.loginInfo, "password", null);
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.loginInfo.password,
      expression: "loginInfo.password"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: 'required|min:6',
      expression: "'required|min:6'"
    }],
    class: ['input', {
      invalid: _vm.errors.has('password'),
      empty: _vm.loginInfo.password.length <= 0
    }],
    attrs: {
      "id": "password",
      "name": "password",
      "data-testid": "password-input",
      "data-vv-validate-on": "blur",
      "type": _vm.passwordFieldType ? 'password' : 'text'
    },
    domProps: {
      "value": _vm.loginInfo.password
    },
    on: {
      "focus": function ($event) {
        return _vm.$validator.errors.remove('password');
      },
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.loginInfo, "password", $event.target.value);
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "password",
      "data-testid": "password_label"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('placeholders.text.field.password')) + "\n            ")]), _vm._v(" "), !_vm.errors.has('password') || _vm.loginInfo.password.length > 0 ? _c('span', {
    class: ['cursor-pointer icon-password', _vm.passwordFieldType ? 'airalo-icon-eye-slash' : 'airalo-icon-eye', {
      'tw-text-red-600': _vm.errors.has('password')
    }],
    on: {
      "click": function ($event) {
        _vm.passwordFieldType = !_vm.passwordFieldType;
      }
    }
  }) : _vm._e()]), _vm._v(" "), _vm.errors.first('password') ? _c('div', {
    staticClass: "field-error",
    attrs: {
      "data-testid": "password-field-error"
    }
  }, [_c('p', [_vm._v("\n              " + _vm._s(_vm.errors.first('password')) + "\n            ")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "w-100 display-flex justify-content-between align-items-start"
  }, [_c('div', {
    staticClass: "display-flex justify-content-start align-items-center mt-10"
  }, [_c('Toggle', {
    staticClass: "v-middle",
    attrs: {
      "data-testid": "remember-me-toggle",
      "value": _vm.loginInfo.remember_me
    },
    on: {
      "change": function ($event) {
        _vm.loginInfo.remember_me = arguments[0];
      }
    }
  }), _vm._v(" "), _c('span', {
    class: ['typo-checkbox', {
      'ml-10': _vm.$dir() === 'ltr',
      'mr-10': _vm.$dir() === 'rtl'
    }],
    attrs: {
      "data-testid": "remember-me-tittle"
    }
  }, [_vm._v(_vm._s(_vm.$t('components.login.remember')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "display-flex justify-content-start align-items-center"
  }, [_c('nuxt-link', {
    staticClass: "typo-p color-text-primary text-decoration-underline",
    attrs: {
      "to": _vm.localePath({
        name: 'verify-index-respass-1'
      }),
      "data-testid": "forgot-password-link"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('components.login.forgot-password-title')) + "\n          ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "w-100 my-10"
  }, [_c('button', {
    staticClass: "button button-secondary block btn-primary-hv",
    attrs: {
      "type": "button",
      "data-testid": "login-button"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.validate.apply(null, arguments);
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('components.login.cta-button')) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "display-flex justify-content-center align-items-center relative mt-10 w-100"
  }, [_c('div', {
    staticClass: "centered-y left-0 w-100 h-1 color-bg-lighter z-index-10 line-width-100"
  }), _vm._v(" "), _c('p', {
    staticClass: "display-inline-flex justify-content-center align-items-center mb-0 relative z-index-20 px-20 typo-row color-text-secondary color-bg-body color-bg-white-sm"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('components.login.seperator-text')) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "w-100 mt-20"
  }, [_c('SocialLogin', {
    on: {
      "onClickSocialLink": _vm.onClickSocialLink
    }
  })], 1)])]), _vm._v(" "), _c('client-only', [_c('prompt-modal', {
    attrs: {
      "modal-view": _vm.isAppleNamePromptShown,
      "overlay-view": false,
      "type": "double",
      "text": _vm.$t('components.social.login.title'),
      "button": {
        text: _vm.$t('global.cancel'),
        callbackName: 'closePromptModal',
        isClose: true
      },
      "button-second": {
        text: _vm.$t('global.continue'),
        callbackName: 'submitNameForApple',
        variant: 'prompt-simple-secondary'
      }
    },
    on: {
      "onCloseModal": _vm.closePromptModal,
      "onClickButton": _vm.submitNameForApple
    }
  }, [[_c('div', {
    staticClass: "rename-modal-body mt-10"
  }, [_c('p', {
    staticClass: "esim-rename-subtitle typo-p color-text-secondary text-center mb-0"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('components.social.login.subtitle')) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "display-flex flex-column gap-10 mt-20"
  }, [_c('div', {
    staticClass: "general-input"
  }, [_c('div', {
    class: [`field field-text`, {
      'field-invalid': _vm.errors.has('appleFirstName'),
      'field-filled': _vm.appleFirstName.length
    }]
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.appleFirstName,
      expression: "appleFirstName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: 'required|min:2|max:255',
      expression: "'required|min:2|max:255'"
    }],
    class: ['input', {
      invalid: _vm.errors.has('appleFirstName'),
      empty: _vm.appleFirstName.length <= 0
    }],
    attrs: {
      "id": "appleFirstName",
      "type": "text",
      "name": "appleFirstName",
      "data-vv-validate-on": "blur",
      "data-vv-as": _vm.$t('placeholders.text.field.first-name')
    },
    domProps: {
      "value": _vm.appleFirstName
    },
    on: {
      "focus": function ($event) {
        return _vm.$validator.errors.remove('appleFirstName');
      },
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.appleFirstName = $event.target.value;
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "appleFirstName",
      "data-tid": "appleFirstName_label"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$t('placeholders.text.field.first-name')) + "\n                ")])]), _vm._v(" "), _vm.errors.first('appleFirstName') ? _c('div', {
    staticClass: "field-error"
  }, [_c('p', [_vm._v("\n                  " + _vm._s(_vm.errors.first('appleFirstName')) + "\n                ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "general-input"
  }, [_c('div', {
    class: [`field field-text`, {
      'field-filled': _vm.appleLastName.length
    }]
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.appleLastName,
      expression: "appleLastName"
    }],
    class: ['input', {
      empty: _vm.appleLastName.length <= 0
    }],
    attrs: {
      "id": "apple_last_name",
      "type": "text",
      "name": "apple_last_name",
      "data-vv-as": _vm.$t('placeholders.text.field.last-name')
    },
    domProps: {
      "value": _vm.appleLastName
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.appleLastName = $event.target.value;
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "appleFirstName",
      "data-tid": "appleFirstName_label"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$t('placeholders.text.field.last-name')) + "\n                ")])]), _vm._v(" "), _vm.errors.first('appleFirstName') ? _c('div', {
    staticClass: "field-error"
  }, [_c('p', [_vm._v("\n                  " + _vm._s(_vm.errors.first('appleFirstName')) + "\n                ")])]) : _vm._e()])])])]], 2)], 1)], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }